import { 
    apiRequest,
    strukturOrganisasiUpdate
 } from '../../../../../services/adapters/base'


class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest('post', strukturOrganisasiUpdate, {
            body: query
        }, true)
    }
 
}

export default UpdateRepository
